import { z } from 'zod';

export enum LeadUnlockReason {
    FREE = 'free',
    PREMIUM = 'premium',
    LEGACY = 'legacy', // legacy leads (before free leads were introduced) are visible
    OWN_COMPANY = 'ownCompany',
}

export const LeadAccessSchema = z.object({
    unlockedAt: z.string().nullish(),
    reason: z.nativeEnum(LeadUnlockReason).nullish(),
});

export type LeadAccess = z.infer<typeof LeadAccessSchema>;

export const FREE_LEADS_LIMIT = 5;

export enum LeadSource {
    QR_SCAN = 'qrScan',
    MESSAGE = 'message',
}

export const LockedPreviewSchema = z.object({
    job: z.string().optional(),
    company: z.string().optional(),
    avatar: z.string().optional(),
    hasNote: z.boolean().optional(),
    // The same for all of one person's locked scans and chats with a company, so they show as one lead
    visitor: z.string().optional(),
});

export type LockedPreview = z.infer<typeof LockedPreviewSchema>;

export type FreeLeadsUsage = {
    used: number;
    limit: number;
    unlimited: boolean;
    hasEarlierLeads: boolean;
};
